import { atom } from 'jotai';
import { StoryData } from 'storyblok-js-client';
import { appAtom } from './App.atom';

const articlesAtom = atom<StoryData[]>((get) => get(appAtom)?.articles) ?? [];

export { articlesAtom };
